import { Button, Col, Input, Popconfirm, Space, Table, Tag } from "antd";
import ContainerLayout from "../common/containerLayout";
import "./departments.css";
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  deleteDepartment,
  getDepartments,
  setFiltersDepartments,
} from "../../features/departments/departmentsSlice";
import DepartmentModal from "./departmentModal";

const { Search } = Input;
const { Column } = Table;

const Departments = (): JSX.Element => {
  const departments = useAppSelector((state) => state.departments.values);
  const filters = useAppSelector(
    (state) => state.departments.filtersDepartments,
  );
  const loading = useAppSelector((state) => state.departments.loading);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getDepartments({ ...filters }));
  }, [dispatch, filters]);

  const onSearch = (value: string) => {
    const newFilters = { ...filters, page: 1, searchText: value };
    dispatch(setFiltersDepartments(newFilters));
  };

  const handleOnClickDelete = (id: string) => {
    dispatch(deleteDepartment(id));
  };

  const onChangePagination = (page: number, pageSize: number) => {
    const newFilters = { ...filters, page, take: pageSize };
    dispatch(setFiltersDepartments(newFilters));
  };

  const showTotal = (total: number) => `Total  ${total} departamentos`;

  return (
    <ContainerLayout title="Departamentos" showNotification={false}>
      <Col span={24}>
        <Space>
          <DepartmentModal />
          <Search
            placeholder="Buscar..."
            onSearch={onSearch}
            style={{ maxWidth: 400 }}
            allowClear
            loading={loading}
            disabled={loading}
          />
        </Space>
      </Col>
      <Col span={24} style={{ width: "100px", height: "83vh" }}>
        <Table
          size="middle"
          dataSource={departments?.departments}
          rowKey="id"
          loading={loading}
          pagination={{
            total: departments?.total,
            current: filters?.page,
            onChange: onChangePagination,
            hideOnSinglePage: true,
            showSizeChanger: false,
            size: "default",
            showTotal,
          }}
        >
          <Column title="ID" dataIndex="id" />
          <Column title="Nombre" dataIndex="name" />
          <Column
            title=""
            width={200}
            render={(record) => (
              <>
                <Space>
                  <DepartmentModal
                    create={false}
                    getValuesToEdit={() => ({
                      id: record?.id,
                      name: record?.name,
                    })}
                  />
                  <Popconfirm
                    placement="topLeft"
                    title={
                      <>
                        Está seguro(a) que desea eliminar el departamento?{" "}
                        <Tag color="red">{record?.name}</Tag>
                      </>
                    }
                    onConfirm={() => handleOnClickDelete(record?.id)}
                    okText="Aceptar"
                    cancelText="Cancelar"
                  >
                    <Button type="primary" color="danger" variant="solid">
                      Eliminar
                    </Button>
                  </Popconfirm>
                </Space>
              </>
            )}
          />
        </Table>
      </Col>
    </ContainerLayout>
  );
};

export default Departments;
